<div class="flex row align-space-between justify-center">
    <div></div>
    @if (siteConfig$ | async; as siteConfig) {
        <mat-card appearance="outlined" class="flex-60">
            @switch (state) {
                @default {
                    <div>
                        <mat-card-header>
                            <mat-card-title>Name the Workspace</mat-card-title>
                            <mat-card-subtitle>Step 1 of 3</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <mat-form-field appearance="fill">
                                <mat-label>Workspace Name</mat-label>
                                <input
                                    matInput
                                    [formControl]="nameControl"
                                    (ngModelChange)="siteConfig.data.name = $event"
                                    required
                                />
                            </mat-form-field>
                        </mat-card-content>
                        <mat-card-actions>
                            <button
                                mat-flat-button
                                color="primary"
                                (click)="next(siteConfig)"
                                [disabled]="!nameControl.valid"
                            >
                                Next
                            </button>
                        </mat-card-actions>
                    </div>
                }
                @case (SetupState.Stream) {
                    <div>
                        <mat-card-header>
                            <mat-card-title>Name the stream</mat-card-title>
                            <mat-card-subtitle>Step 2 of 3</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <p>
                                A Stream is a loose collection of content, you'll need at least one
                                to get going. The name isn't permanent and can be changed any time
                            </p>
                            <mat-form-field appearance="fill">
                                <mat-label>Stream Name</mat-label>
                                <input matInput [formControl]="streamControl" />
                            </mat-form-field>
                        </mat-card-content>
                        <mat-card-actions>
                            <button mat-flat-button color="primary" (click)="next(siteConfig)">
                                Next
                            </button>
                        </mat-card-actions>
                    </div>
                }
                @case (SetupState.Invites) {
                    <div>
                        <mat-card-header>
                            <mat-card-title>Invite Others</mat-card-title>
                            <mat-card-subtitle>Step 3 of 3</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <frog-invites
                                [withLink]="true"
                                [clientId]="siteConfig.client_id"
                            ></frog-invites>
                        </mat-card-content>
                        <mat-card-actions>
                            <button mat-flat-button color="primary" (click)="next(siteConfig)">
                                Add Teammates
                            </button>
                            <button mat-button (click)="skipInvitations(siteConfig)">
                                Skip For Now
                            </button>
                        </mat-card-actions>
                    </div>
                }
            }
        </mat-card>
    }
    <div></div>
</div>
